const e={"x-descope-sdk-name":"react","x-descope-sdk-version":"2.3.7"},d="undefined"!=typeof window;export{d as IS_BROWSER,e as baseHeaders};
//# sourceMappingURL=constants.js.map
